import { createSharedComposable } from '@vueuse/core';
import { ref } from 'vue';

export const useConversationLayout = createSharedComposable(() => {
  const isDetailOpened = ref(false);
  const isDetailExpanded = ref(false);
  const expandRerender = ref(true);

  const toggleDetail = (newState?: boolean) => {
    if (newState !== undefined) {
      isDetailOpened.value = newState;
    } else {
      isDetailOpened.value = !isDetailOpened.value;
    }

    if (!isDetailOpened.value) {
      // when detail is closed, reset expanded state to false
      isDetailExpanded.value = false;
    }
  };

  const toggleDetailExpansion = (newState?: boolean) => {
    if (newState !== undefined) {
      isDetailExpanded.value = newState;
    } else {
      isDetailExpanded.value = !isDetailExpanded.value;
    }
  };

  return {
    isDetailOpened,
    toggleDetail,
    isDetailExpanded,
    toggleDetailExpansion,
    expandRerender,
  };
});
